module.exports = __webpack_public_path__ + "static/SharpSans-light-459d3df07e8bca1b80b18129bd059df4.otf";